module.exports = __webpack_public_path__ + "static/media/icon-catalog-shipping-truck.401d1838.svg";